import React, { useState } from 'react'
import Popup from '../components/Popup';
import { Typography } from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { NPOVerifyOTP, NPOResetPassword } from '../../../../Store/auth/login';
import CustomInput from '../../../InputCompo/CustomInput';
import { enqueueSnackbar } from 'notistack';

const OtpPopup = ({ isOpen, onClose, email }) => {
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpValue, setOtpValue] = useState('');

  // OTP Formik
  const otpFormik = useFormik({
    initialValues: {
      otp: '',
    },
    validationSchema: Yup.object({
      otp: Yup.string().required('OTP is required'),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const updatedData = {
          otp: values.otp,
          email: email,
        };
        await NPOVerifyOTP(updatedData);
        setOtpVerified(true);
        setOtpValue(values.otp);
      } catch (error) {
        enqueueSnackbar(error?.response?.data?.status_message  , {variant: "error"});
      } finally {
        setSubmitting(false);
      }
    },
  });

  // Password Formik
  const passwordFormik = useFormik({
    initialValues: {
      password: '',
    },
    validationSchema: Yup.object({
      password: Yup.string().required('Password is required'),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const payload = {
          otp: otpValue,
          email: email,
          new_password: values.password,
        };
        await NPOResetPassword(payload);
        onClose(); // Close popup after successful reset
      } catch (error) {
        enqueueSnackbar(error?.response?.data?.status_message  , {variant: "error"});
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Popup isOpen={isOpen} onClose={onClose} text={otpVerified ? "Set New Password" : "Enter your OTP"}>
      <Typography
        variant="subtitle1"
        sx={{ textAlign: "center", width: "360px" }}
      >
        {otpVerified
          ? "Please enter your new password."
          : "Please enter the OTP sent to your email."}
      </Typography>
      {!otpVerified ? (
        <form onSubmit={otpFormik.handleSubmit} className="flex flex-col items-center mt-4">
          <CustomInput
            required
            {...otpFormik.getFieldProps("otp")}
            name="otp"
            label="Enter your OTP"
            onBlur={otpFormik.handleBlur}
          />
          {otpFormik.touched.otp && otpFormik.errors.otp && (
            <Typography color="error" variant="caption">{otpFormik.errors.otp}</Typography>
          )}
          <button
            type="submit"
            className="mt-4 px-6 py-2 bg-[#ED1C24] text-white rounded-full"
            disabled={otpFormik.isSubmitting}
          >
            Submit OTP
          </button>
        </form>
      ) : (
        <form onSubmit={passwordFormik.handleSubmit} className="flex flex-col items-center mt-4">
          <CustomInput
            required
            type="password"
            {...passwordFormik.getFieldProps("password")}
            name="password"
            label="Enter new password"
            onBlur={passwordFormik.handleBlur}
          />
          {passwordFormik.touched.password && passwordFormik.errors.password && (
            <Typography color="error" variant="caption">{passwordFormik.errors.password}</Typography>
          )}
          <button
            type="submit"
            className="mt-4 px-6 py-2 bg-[#ED1C24] text-white rounded-full"
            disabled={passwordFormik.isSubmitting}
          >
            Set Password
          </button>
        </form>
      )}
    </Popup>
  )
};

export default OtpPopup;